import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { getUserInfo } from 'Store/Auth/Auth.selector';

interface ITenantRoleRoute {
  roles: number[];
  redirectTo: string;
  children: ReactNode;
}

// Guarda de rota pelo papel do usuário no tenant corrente (TenantRole).
//
// O isPermissionUser das rotas em MainSwitch só filtra o menu lateral: quem digita
// a URL chega na tela mesmo assim. Este componente fecha a rota de fato.
const TenantRoleRoute: FC<ITenantRoleRoute> = ({
  roles,
  redirectTo,
  children,
}) => {
  const userInfo = useSelector(getUserInfo);
  const isLoading = useSelector(
    (state: IGlobalReducerState) => state.auth.isLoading
  );

  // Enquanto o userInfo não chegou não dá para decidir. Redirecionar aqui jogaria
  // o usuário autorizado para fora a cada refresh.
  if (isLoading || !userInfo) return null;

  if (
    userInfo.CurrentRoleFk === undefined ||
    !roles.includes(userInfo.CurrentRoleFk)
  ) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default TenantRoleRoute;
